import { Link } from "react-router-dom";
import { Store, Wrench, ArrowRight } from "lucide-react";
import HeroVisual from "../components/heroVisual";
import { useTranslation } from "../../../i18n/useTranslation";

const Home = () => {
  const { t } = useTranslation();

  const STEPS = [
    { n: "01", title: t("deviceworks.home.step1Title"), body: t("deviceworks.home.step1Body") },
    { n: "02", title: t("deviceworks.home.step2Title"), body: t("deviceworks.home.step2Body") },
    { n: "03", title: t("deviceworks.home.step3Title"), body: t("deviceworks.home.step3Body") },
  ];

  const INDUSTRIES = [
    t("deviceworks.home.industryRetail"),
    t("deviceworks.home.industryDistribution"),
    t("deviceworks.home.industryWarehousing"),
    t("deviceworks.home.industryManufacturing"),
  ];

  return (
    <div>
      {/* hero */}
      <div className="max-w-6xl mx-auto px-5 pt-16 pb-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <div className="dw-eyebrow mb-3">{t("deviceworks.home.eyebrow")}</div>
          <h1>{t("deviceworks.home.heroTitleLine1")}<br />{t("deviceworks.home.heroTitleLine2")}</h1>
          <p className="dw-mini pt-4 max-w-md">{t("deviceworks.home.heroSub")}</p>
          <div className="pt-6 flex gap-3 flex-wrap">
            <Link to="/solutions/deviceworks/get-a-quote" className="dw-btn">{t("deviceworks.home.ctaQuote")}</Link>
            <Link to="/solutions/deviceworks/how-we-work" className="dw-btn-outline">{t("deviceworks.home.ctaHowWeWork")}</Link>
          </div>
        </div>
        <HeroVisual />
      </div>

      {/* pull quote */}
      <div className="dw-panel-bg py-14 px-5 border-y" style={{ borderColor: "var(--dw-line)" }}>
        <p className="max-w-2xl mx-auto text-center text-xl md:text-2xl" style={{ fontFamily: "Outfit", fontWeight: 500 }}>
          {t("deviceworks.home.pullQuote")}
        </p>
      </div>

      {/* how it works */}
      <div className="dw-panel-bg py-16 px-5 border-y" style={{ borderColor: "var(--dw-line)" }}>
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <div className="dw-eyebrow mb-2">{t("deviceworks.home.howItWorksEyebrow")}</div>
            <h2>{t("deviceworks.home.howItWorksHeading")}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {STEPS.map((s) => (
              <div key={s.n} className="dw-card">
                <span className="dw-mono text-sm" style={{ color: "var(--dw-accent)" }}>{s.n}</span>
                <h3 className="pt-2">{s.title}</h3>
                <p className="dw-mini pt-1 text-sm">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* marketplace + lifecycle teasers */}
      <div className="max-w-5xl mx-auto px-5 py-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="dw-card">
          <Store size={28} strokeWidth={1.5} style={{ color: "var(--dw-accent)" }} />
          <span className="dw-badge-outline inline-block mt-2">{t("deviceworks.home.marketplaceComingSoon")}</span>
          <h3 className="pt-2">{t("deviceworks.home.marketplaceTitle")}</h3>
          <p className="dw-mini pt-1 text-sm">{t("deviceworks.home.marketplaceBody")}</p>
          <Link to="/solutions/deviceworks/marketplace" className="dw-link text-sm inline-flex items-center gap-1 pt-3">
            {t("deviceworks.home.marketplaceLink")} <ArrowRight size={14} />
          </Link>
        </div>
        <div className="dw-card">
          <Wrench size={28} strokeWidth={1.5} style={{ color: "var(--dw-accent)" }} />
          <h3 className="pt-2">{t("deviceworks.home.lifecycleTitle")}</h3>
          <p className="dw-mini pt-1 text-sm">{t("deviceworks.home.lifecycleBody")}</p>
          <Link to="/solutions/deviceworks/lifecycle-services" className="dw-link text-sm inline-flex items-center gap-1 pt-3">
            {t("deviceworks.home.lifecycleLink")} <ArrowRight size={14} />
          </Link>
        </div>
      </div>

      {/* industries */}
      <div className="dw-panel-bg py-16 px-5 border-y" style={{ borderColor: "var(--dw-line)" }}>
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <div className="dw-eyebrow mb-2">{t("deviceworks.home.industriesEyebrow")}</div>
            <h2>{t("deviceworks.home.industriesHeading")}</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {INDUSTRIES.map((ind) => (
              <div key={ind} className="dw-card text-center">
                <h3 className="text-base">{ind}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA band */}
      <div className="max-w-3xl mx-auto px-5 py-20 text-center">
        <h2>{t("deviceworks.home.ctaHeading")}</h2>
        <p className="dw-mini pt-3">{t("deviceworks.home.ctaSub")}</p>
        <Link to="/solutions/deviceworks/get-a-quote" className="dw-btn inline-flex mt-6">{t("deviceworks.home.ctaButton")}</Link>
      </div>
    </div>
  );
};

export default Home;
